module.exports = {
  title: 'Stacked Action Tray with Reanimated and Gesture Handler',
  author: 'Enzo Manuel Mangano',
  date: '2024-03-13',
  slug: 'stacked-bottom-sheet',
  tags: ['reanimated', 'gesture-handler'],
};
